import { Builder } from '@builder.io/react';

import Stats from './index';

Builder.registerComponent(Stats, {
  name: 'StatsGrid',
  inputs: [
    {
      name: 'marginBottom',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'color',
      type: 'string'
    },
    {
      name: 'stats',
      type: 'list',
      subFields: [
        {
          name: 'doubleSpan',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'title',
          type: 'string'
        },
        {
          name: 'value',
          type: 'string'
        },
        {
          name: 'featured',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'icon',
          type: 'object',
          subFields: [
            {
              name: 'src',
              type: 'file',
              allowedFileTypes: ['svg']
            },
            {
              name: 'alt',
              type: 'string'
            },
            {
              name: 'width',
              type: 'number '
            },
            {
              name: 'height',
              type: 'number '
            }
          ]
        }
      ]
    }
  ]
});
